export enum ProviderTypes {
    Unknown = 0,
    Alpaca = 1,
    WhiteHatBots = 2,
    Webull = 3,
    Public = 4,
}
